<template>
	<div>
		<NkAlert
			v-if="success"
			variant="success"
			:closeable="false"
			:title="successMessage"
			:description="successDescription"
		/>
		<NkAlert
			v-if="error"
			variant="danger"
			:closeable="false"
			:title="errorMessage"
			:description="errorDescription"
		/>

		<template v-if="!success && !error">
			<nk-paragraph size="md">
				Möchten Sie Ihre Reservierung wirklich stornieren?
			</nk-paragraph>
			<nk-button :is-loading="isLoading" @click="cancleBooking">
				Reservierung stornieren
			</nk-button>
		</template>

		<nk-wrapper v-if="success" spacing="md">
			<nk-paragraph>
				<nk-button link="/de/ebike-leihen/">Zurück zum Formular</nk-button>
			</nk-paragraph>
		</nk-wrapper>
	</div>
</template>

<script>
const apiPostReservierung = '/automation/webhook/lossburg-ebike-stornieren';
export default {
	data() {
		return {
			error: false,
			errorMessage: 'Reservierung konnte nicht storniert werden',
			errorDescription:
				'Leider konnte Ihre Anfrage nicht storniert werden. Bitte wenden Sie sich bei Fragen an <a href="mailto:lossburg-information@lossburg.de">lossburg-information@lossburg.de</a>',
			success: false,
			successMessage: 'Reservierung storniert',
			successDescription:
				'Ihre Reservierung wurde erfolgreich storniert. Sie erhalten in Kürze eine Bestätigung per E-Mail',
			isLoading: false,
		};
	},
	methods: {
		async cancleBooking() {
			this.isLoading = true;
			try {
				await this.$axios.$post(apiPostReservierung, {
					uuid: this.$route.query.uuid,
				});

				this.success = true;
			} catch {
				this.error = true;
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>
